import type { DocumentFolder, LoanDocument } from '../types/documents';

export const documentFolders: DocumentFolder[] = [
  { id: 'assets', name: 'Assets' },
  { id: 'income', name: 'Income' },
  { id: 'credit', name: 'Credit' },
  { id: 'insurance', name: 'Insurance' },
  { id: 'title', name: 'Title & Escrow' },
  { id: 'contract', name: 'Purchase Contract' },
  { id: 'borrower', name: 'Borrower Uploads' },
];

export const loanDocuments: LoanDocument[] = [
  {
    id: 'd1',
    name: 'Vesting_Election_Signed.pdf',
    type: 'Vesting Form',
    folderId: 'borrower',
    source: 'Borrower Portal',
    uploadedAt: '2026-10-11',
    uploadedBy: 'Sarah Johnson',
    pages: 2,
  },
  {
    id: 'd2',
    name: 'HOI_Declarations_Page_2026.pdf',
    type: 'Insurance',
    folderId: 'insurance',
    source: 'Email Inbox',
    uploadedAt: '2026-10-10',
    uploadedBy: 'State Farm Agent',
    pages: 3,
  },
  {
    id: 'd3',
    name: 'Chase_Statement_Aug_4821.pdf',
    type: 'Bank Statement',
    folderId: 'assets',
    source: 'Borrower Portal',
    uploadedAt: '2026-10-02',
    uploadedBy: 'Michael Johnson',
    pages: 6,
    attachedTo: 'Bank Statements',
  },
  {
    id: 'd4',
    name: 'Chase_Statement_Sep_4821.pdf',
    type: 'Bank Statement',
    folderId: 'assets',
    source: 'Borrower Portal',
    uploadedAt: '2026-10-02',
    uploadedBy: 'Michael Johnson',
    pages: 6,
    attachedTo: 'Bank Statements',
  },
  {
    id: 'd5',
    name: 'Preliminary_Title_Report.pdf',
    type: 'Title',
    folderId: 'title',
    source: 'Loan File',
    uploadedAt: '2026-10-09',
    uploadedBy: 'Priya Patel',
    pages: 14,
  },
  {
    id: 'd6',
    name: 'Credit_Inquiry_LOE.pdf',
    type: 'Letter of Explanation',
    folderId: 'credit',
    source: 'Borrower Portal',
    uploadedAt: '2026-10-10',
    uploadedBy: 'Michael Johnson',
    pages: 1,
    attachedTo: 'Letter of Explanation',
  },
  {
    id: 'd7',
    name: 'Purchase_Contract_Executed.pdf',
    type: 'Purchase Agreement',
    folderId: 'contract',
    source: 'Encompass Import',
    uploadedAt: '2026-09-15',
    uploadedBy: 'Nicole Davis',
    pages: 22,
  },
  {
    id: 'd8',
    name: 'Paystubs_Sep_2026.pdf',
    type: 'Income',
    folderId: 'income',
    source: 'Borrower Portal',
    uploadedAt: '2026-10-01',
    uploadedBy: 'Sarah Johnson',
    pages: 2,
  },
  {
    id: 'd9',
    name: 'W2_2025_Employer.pdf',
    type: 'Income',
    folderId: 'income',
    source: 'Loan File',
    uploadedAt: '2026-09-20',
    uploadedBy: 'Nicole Davis',
    pages: 1,
  },
  {
    id: 'd10',
    name: 'Credit_Report_Tri_Merge.pdf',
    type: 'Credit Report',
    folderId: 'credit',
    source: 'Encompass Import',
    uploadedAt: '2026-09-16',
    uploadedBy: 'Nicole Davis',
    pages: 18,
  },
];
